	// =========================================================
// CONFIGURATION
// =========================================================

// UPDATE: Replace with your main marker coordinates
// (from https://maps.app.goo.gl/pB9KyFW7Q81QNm3a7)
const CENTER_LAT = 48.4147533626599;
const CENTER_LNG = -123.37606175697222;
const MAP_ZOOM = 15; 

// =========================================================
// LOCATION DATA — James Bay, Victoria, BC
// =========================================================
const locations = {
	restaurants: [
		{ name: "IL Covo Trattoria", address: "106 Superior St, Victoria, BC", lat: 48.421825, lng: -123.380579 },
		{ name: "Blue Crab Seafood House", address: "146 Kingston St, Victoria, BC", lat: 48.422146, lng: -123.379580 },
		{ name: "Nourish Kitchen & Cafe", address: "225 Quebec St, Victoria, BC", lat: 48.421702, lng: -123.376804 },
		{ name: "Belleville's", address: "427 Belleville St, Victoria, BC", lat: 48.421068, lng: -123.373162 },
		{ name: "Fathom", address: "463 Belleville St, Victoria, BC", lat: 48.420619, lng: -123.372190 },
		{ name: "Floyd's Diner James Bay", address: "425 Quebec St, Victoria, BC", lat: 48.420050, lng: -123.373150 },
		{ name: "Heron Rock Bistro", address: "435 Simcoe St, Victoria, BC", lat: 48.415768, lng: -123.375610 },
		{ name: "Breakwater Bistro & Bar", address: "199 Dallas Rd, Victoria, BC", lat: 48.415408, lng: -123.384747 },
		{ name: "Levantine Middle Eastern Restaurant", address: "225 Menzies St #103, Victoria, BC", lat: 48.416009, lng: -123.373295 },
		{ name: "Real Thai Restaurant", address: "211 Menzies St, Victoria, BC", lat: 48.415655, lng: -123.373504 },
	],
	"cafes-grocery": [
		{ name: "Thrifty Foods James Bay", address: "475 Simcoe St, Victoria, BC", lat: 48.415434, lng: -123.374623 },
		{ name: "Red Barn Market", address: "325 Menzies St, Victoria, BC", lat: 48.417127, lng: -123.372700 },
		{ name: "Discovery Coffee", address: "281 Menzies St, Victoria, BC", lat: 48.416756, lng: -123.372770 },
		{ name: "Whippletree Bakery", address: "209 Menzies St, Victoria, BC", lat: 48.415620, lng: -123.373606 },
		{ name: "Imagine Studio Café", address: "31 Erie St, Victoria, BC", lat: 48.421197, lng: -123.383432 },
		{ name: "Duo Café Bakery", address: "680 Montreal St, Victoria, BC", lat: 48.423530, lng: -123.376689 },
		{ name: "Courtyard Cafe", address: "463 Belleville St #3, Victoria, BC", lat: 48.420963, lng: -123.372512 },
		{ name: "Birdcage Confectionary", address: "501 Government St, Victoria, BC", lat: 48.417292, lng: -123.368721 },
		{ name: "Piggy & Paisley", address: "143 Menzies St, Victoria, BC", lat: 48.415093, lng: -123.374020 },
	],
	"parks-beaches": [
		{ name: "Beacon Hill Park", address: "100 Cook St, Victoria, BC", lat: 48.412222, lng: -123.362778 },
		{ name: "Fisherman's Wharf Park", address: "12 Erie St, Victoria, BC", lat: 48.421950, lng: -123.383014 },
		{ name: "Holland Point Park", address: "561 Dallas Rd, Victoria, BC", lat: 48.411122, lng: -123.376186 },
		{ name: "Finlayson Point", address: "Dallas Rd, Victoria, BC", lat: 48.406583, lng: -123.364644 },
		{ name: "Breakwater Lighthouse", address: "The Breakwater, Victoria, BC", lat: 48.413519, lng: -123.393825 },
		{ name: "Beacon Hill Lookout", address: "Beacon Hill Loop, Victoria, BC", lat: 48.409969, lng: -123.364472 },
		{ name: "Steve Fonyo Beach", address: "645 Dallas Rd, Victoria, BC", lat: 48.409118, lng: -123.372867 },
		{ name: "Irving Park", address: "250 Menzies St, Victoria, BC", lat: 48.416552, lng: -123.373546 },
		{ name: "MacDonald Park", address: "212 Niagara St, Victoria, BC", lat: 48.417548, lng: -123.380768 },
		{ name: "Spiral Beach", address: "1119 Dallas Rd, Victoria, BC", lat: 48.407298, lng: -123.357062 },
		{ name: "Stan's Beach", address: "Dallas Rd, Victoria, BC", lat: 48.412852, lng: -123.379845 },
	],
	"services-recreation": [
		{ name: "Black Ball Ferry Line", address: "430 Belleville St, Victoria, BC", lat: 48.421297, lng: -123.372051 },
		{ name: "Victoria Harbour Ferry", address: "12 Erie St, Victoria, BC", lat: 48.422741, lng: -123.382404 },
		{ name: "Victoria, BC Cruise Ship Dock", address: "185 Dallas Rd, Victoria, BC", lat: 48.414978, lng: -123.389541 },
		{ name: "Pure Integrative Pharmacy", address: "557 Superior St #102, Victoria, BC", lat: 48.417892, lng: -123.369878 },
		{ name: "Pharmasave James Bay", address: "230 Menzies St #113, Victoria, BC", lat: 48.415691, lng: -123.374277 },
		{ name: "BC Liquor Stores James Bay", address: "225 Menzies St #101, Victoria, BC", lat: 48.415796, lng: -123.373444 },
		{ name: "FINE FLORAL DESIGNS", address: "159 Menzies St, Victoria, BC", lat: 48.415250, lng: -123.373884 },
		{ name: "James Bay Pet Supplies", address: "300 Beckley Ave, Victoria, BC", lat: 48.416327, lng: -123.379532 },
		{ name: "James Bay Veterinary Clinic", address: "239 Menzies St #101, Victoria, BC", lat: 48.416228, lng: -123.373187 },
		{ name: "James Bay Podiatry", address: "230 Menzies St #101, Victoria, BC", lat: 48.415864, lng: -123.374005 },
		{ name: "Lab Health Physio", address: "527 Fraser St, Victoria, BC", lat: 48.428638, lng: -123.412508 },
		{ name: "James Bay Urgent and Primary Care Centre", address: "547 Michigan St B, Victoria, BC", lat: 48.416748, lng: -123.371317 },
		{ name: "LifeLabs Medical Laboratory Services", address: "547 Michigan St #210, Victoria, BC", lat: 48.416778, lng: -123.371212 },
		{ name: "Tall Tree Health", address: "555 Superior St, Victoria, BC", lat: 48.417950, lng: -123.369948 },
		{ name: "James Bay Community Centre", address: "140 Oswego St, Victoria, BC", lat: 48.416741, lng: -123.379812 },
		{ name: "James Bay Market", address: "494 Superior St, Victoria, BC", lat: 48.418380, lng: -123.372625 },
		{ name: "James Bay Community Project", address: "547 Michigan St, Victoria, BC", lat: 48.416798, lng: -123.371298 },
	],
	"education-daycare": [
		{ name: "James Bay Community School", address: "140 Oswego St, Victoria, BC", lat: 48.417081, lng: -123.379624 },
		{ name: "Sir James Douglas Elementary", address: "401 Moss St, Victoria, BC", lat: 48.415467, lng: -123.348532 },
		{ name: "Vancouver Island School of Art", address: "733 Johnson St #302, Victoria, BC", lat: 48.426758, lng: -123.363171 },
		{ name: "Little Waves Daycare", address: "140 Oswego St, Victoria, BC", lat: 48.417048, lng: -123.379657 },
		{ name: "Blue Heron Montessori", address: "205 Simcoe St, Victoria, BC", lat: 48.418635, lng: -123.381360 },
		{ name: "Rainbow Express Day Care", address: "433 Kingston St, Victoria, BC", lat: 48.419650, lng: -123.374463 },
	],
};

// =========================================================
// CUSTOM MAP STYLE
// =========================================================
const mapStyle = [
	{
		elementType: "geometry",
		stylers: [{ color: "#E5E5DE" }],
	},
	{
		elementType: "labels.text.fill",
		stylers: [{ color: "#333D4F" }],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [{ color: "#E5E5DE" }],
	},
	{
		featureType: "administrative",
		elementType: "geometry.stroke",
		stylers: [{ color: "#333D4F" }, { lightness: 40 }],
	},
	{
		featureType: "road",
		elementType: "geometry",
		stylers: [{ color: "#ffffff" }],
	},
	{
		featureType: "road",
		elementType: "geometry.stroke",
		stylers: [{ color: "#d6d6d0" }],
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [{ color: "#ffffff" }],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [{ color: "#c8c8c2" }],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [{ color: "#333D4F" }, { lightness: 30 }],
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [{ color: "#E5E5DE" }],
	},
	{
		featureType: "poi",
		elementType: "geometry",
		stylers: [{ color: "#d9d9d2" }],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [{ color: "#c8d4c0" }],
	},
	{
		featureType: "transit",
		elementType: "geometry",
		stylers: [{ color: "#d0d0ca" }],
	},
	{
		featureType: "poi",
		elementType: "labels.icon",
		stylers: [{ visibility: "off" }],
	},
];

// =========================================================
// SVG MARKER — Circle with "+" in #B05926
// =========================================================
function createMarkerIcon() {
	const svg = `
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
			<circle cx="16" cy="16" r="14" fill="#B05926" stroke="#fff" stroke-width="2"/>
			<line x1="16" y1="9" x2="16" y2="23" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>
			<line x1="9" y1="16" x2="23" y2="16" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>
		</svg>`;
	return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
}

// =========================================================
// PLACEHOLDER CENTER MARKER
// Update this with your custom marker image/icon
// =========================================================
function createCenterMarkerIcon() {
	const svg = `
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="52" viewBox="0 0 40 52">
			<path d="M20 0C8.954 0 0 8.954 0 20c0 14 20 32 20 32s20-18 20-32C40 8.954 31.046 0 20 0z" fill="#333D4F"/>
			<circle cx="20" cy="18" r="8" fill="#E5E5DE"/>
		</svg>`;
	return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
}

// =========================================================
// MAP INIT
// =========================================================
let map;
let markers = [];
let activeInfoWindow = null;

  function initMap() {
	map = new google.maps.Map(document.getElementById("map"), {
		center: { lat: CENTER_LAT, lng: CENTER_LNG },
		zoom: MAP_ZOOM,
		styles: mapStyle,
		disableDefaultUI: false,
		mapTypeControl: false,
	});

	// Center marker
	new google.maps.Marker({
		position: { lat: CENTER_LAT, lng: CENTER_LNG },
		map: map,
		icon: {
			url: createCenterMarkerIcon(),
			scaledSize: new google.maps.Size(40, 52),
			anchor: new google.maps.Point(20, 52),
		},
		zIndex: 999,
	});

	// Load default category
	showCategory("restaurants");

	// Button handlers
	document.querySelectorAll(".category-btn").forEach((btn) => {
		btn.addEventListener("click", function () {
			document.querySelectorAll(".category-btn").forEach((b) => b.classList.remove("active"));
			this.classList.add("active");
			showCategory(this.dataset.category);
		});
	});
}

function showCategory(category) {
	markers.forEach((m) => m.setMap(null));
	markers = [];

	if (activeInfoWindow) {
		activeInfoWindow.close();
		activeInfoWindow = null;
	}

	const items = locations[category] || [];

	items.forEach((loc) => {
		const marker = new google.maps.Marker({
			position: { lat: loc.lat, lng: loc.lng },
			map: map,
			icon: {
				url: createMarkerIcon(),
				scaledSize: new google.maps.Size(32, 32),
				anchor: new google.maps.Point(16, 16),
			},
			title: loc.name,
		});

		const infoWindow = new google.maps.InfoWindow({
			content: `
				<div style="font-family: sans-serif; padding: 4px 0;">
					<strong style="font-size: 14px; color: #333D4F;">${loc.name}</strong><br>
					<span style="font-size: 13px; color: #666;">${loc.address}</span>
				</div>
			`,
		});

		marker.addListener("click", () => {
			if (activeInfoWindow) activeInfoWindow.close();
			infoWindow.open(map, marker);
			activeInfoWindow = infoWindow;
		});

		markers.push(marker);
	});

	if (markers.length > 0) {
		const bounds = new google.maps.LatLngBounds();
		markers.forEach((m) => bounds.extend(m.getPosition()));
		map.fitBounds(bounds, 40);
	}
}